// import cookie from 'js-cookie'
import qs from 'qs'
import { useUserStore } from 'store/userInfo.store'
import { sanitizeParam } from './sanitizeParams'
export const getParams = (prm) => {
  const currentUser = useUserStore.getState()?.userInfo
  // console.log({currentUser})
  // const user = cookie.get('user') && JSON.parse(cookie.get('user'))
  // const access_token = cookie.get('token')

  if (currentUser) {
    if (prm) {
      prm.id_user = currentUser?.id
      prm.ip_address = currentUser?.ipAddress
      prm.browser = currentUser?.browser
      prm.user_token = currentUser?.user_token
      prm.access_token = currentUser?.token
    } else {
      // prm = { id_user: user.id }
      prm = { id_user: currentUser?.id, ip_address: currentUser?.ipAddress, browser: currentUser?.browser, user_token: currentUser?.user_token, access_token:currentUser?.token }
    }

    return qs.parse(qs.stringify(sanitizeParam(prm)))

    // return qs.parse(qs.stringify(prm))
  }
  return null
}

export const postParams = (prm) => {
  const currentUser = useUserStore.getState()?.userInfo
  // const user = cookie.get('user') && JSON.parse(cookie.get('user'))
  // const access_token = cookie.get('token')
  if (currentUser) {
    // prm ? prm.id_user = user.id : prm = { id_user: user.id }
    if (prm) {
      prm.id_user = currentUser?.id
      prm.ip_address = currentUser?.ipAddress
      prm.browser = currentUser?.browser
      prm.user_token = currentUser?.user_token
      prm.access_token = currentUser?.token
    } else {
      // prm = { id_user: user.id }
      prm = { id_user: currentUser?.id, ip_address: currentUser?.ipAddress, browser: currentUser?.browser, user_token: currentUser?.user_token, access_token:currentUser?.token }
    }
    const params = new URLSearchParams()
    // // console.log(sanitizeParam(prm))
    // params.append('P_REQUEST', JSON.stringify(prm))
    params.append('P_REQUEST', JSON.stringify(sanitizeParam(prm)))
    return params
  }
  return null
}
